// Check for the igloo object
if (typeof window.igloo === 'undefined') {
  window.igloo = require('./IglooModule');

  // Create additional variables
  window.igloo.top = window;
  // Create the utils, timer, tracker, and auctioneer instances
  window.igloo.utils = require('./IglooUtils');
  window.igloo.timer = require('./IglooTimer')(window.igloo);
  window.igloo.tracker = require('./IglooTracker')(window.igloo);
  window.igloo.auctioneer = require('./IglooAuctioneer')(window.igloo);
}

// Add to the ad zone
require('./iglooAddZone');
